import React, { useState, useEffect  } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import { jwtDecode } from 'jwt-decode';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Container = styled.div`
  overflow: hidden;
  width: 100%;
`;

const Title = styled.div`
  font-size: 40px;
  display: flex;
  color: #385963;
  font-weight: 600;
  margin-bottom: 20px;
  justify-content: center;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

const Form = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px 50px 50px;
  padding: 40px 50px;
  border-radius: 16px;
  background: linear-gradient(135deg, #f9f9f9, #ffffff);
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.15);
`;

const InfoForm = styled.div`
  color: #385963;
  font-weight: 400;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const FormFields = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
 text-align: center;
`;

const Field = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  p {
    margin: 0;
    font-weight: bold;
  }

  label {
    margin-top: 5px;
  }
`;

const ButtonFlex = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
`;

const Button = styled.button`
  background-color: white;
  color: #385963;
  font-weight: 400;
  border: 2px solid #385963;
  padding: 15px 25px;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  margin: 30px 10px 0;

  &:hover {
    background-color: #385963;
    color: white;
    box-shadow: rgba(0, 0, 0, 0.6) 0px 10px 50px;
  }

  @media (max-width: 768px) {
    font-size: 14px;
    padding: 12px 20px;
  }
`;

const DeleteContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  h5 {
    color: #385963;
    margin-bottom: 20px;
    text-align: center;
  }
`;

const ProfileInfo = ({profile}) => {

const BASE_URL = process.env.REACT_APP_BASE_URL;
const tokenString = sessionStorage.getItem("token");
const navigate = useNavigate();
const { i18n } = useTranslation();
const currentLanguage = i18n.language;
const [deleteProfile, setDeleteProfile] = useState(false); // Track if in edit mode


const deleteAccount = async () => {
  const tokenString = sessionStorage.getItem("token");

  // Check if token exists
  if (!tokenString) {
    console.error("No token found. Please log in.");
    return;
  }

  try {
    const response = await fetch(
      `${BASE_URL}User/delete`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${tokenString}` 
        }
      }
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    if (response.ok) {
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("loggedIn");

      setDeleteProfile(false);
      navigate("/");
      window.location.reload();
      toast.success("Account Deleted");
    } else {
      const errorMessage = await response.text();
      console.error("Deletion failed:", errorMessage);
    }
  } catch (error) {
    console.error("Error during token parsing or request:", error);
  }
};

if (!profile || Object.keys(profile).length === 0) {
  return <div>Loading...</div>;
}

  return (
    <Container>
      <Form>
        {deleteProfile ? (
          <DeleteContainer>
            <h5>{i18n.t('deleteyourAccount')}</h5>
            <ButtonFlex>
              <Button onClick={()=> deleteAccount()}>{i18n.t('delete')}</Button>
              <Button onClick={() => setDeleteProfile(false)}>{i18n.t('cancel')}</Button>
            </ButtonFlex>
          </DeleteContainer>
        ) : (
          <InfoForm>
            <Title>{i18n.t('profileInfo')}</Title>
            {profile.user ? (
              <FormFields>
                <div id='field'><p><strong>{i18n.t('fullname')}:</strong></p> <label>{profile.user.name}</label></div>
                <div id='field'><p><strong>{i18n.t('email')}:</strong> </p><label>{profile.user.email}</label></div>
              </FormFields>
            ) : (
              <p>Loading...</p>
            )}
            {/* <ButtonFlex> */}
              <Button onClick={() => setDeleteProfile(true)}>{i18n.t('deleteAccount')}</Button>
            {/* </ButtonFlex> */}
          </InfoForm>
        )}
      </Form>
    </Container>
  );
};


export default ProfileInfo;